import React from "react";
import "../css/ImagyMarquee.css";
import img1 from "../assets/imagySaludo7.png";
import img2 from "../assets/imagySaludo2.png";
import img3 from "../assets/imagySaludo3.png";
import img4 from "../assets/imagySaludo4.png";
import img5 from "../assets/imagySaludo5.png";
import img6 from "../assets/imagySaludo6.png";
import img7 from "../assets/imagySaludo1.png";


const ImagyMarquee = () => {
  const images = [img1, img2, img3, img4, img5, img6];

  // Duplicamos el array para efecto infinito
  const allImages = [...images, ...images];

  return (
    <div className="marquee-container">
      <h2 className="text-center my-4">Personalizá a Imagy con tu negocio</h2>
      <div className="marquee">
        <div className="marquee-content">
          {allImages.map((img, index) => (
            <img key={index} src={img} alt={`imagy-${index}`} className="marquee-image" />
          ))}
        </div>
      </div>
    </div>
  );
};

export default ImagyMarquee;
